export default __webpack_public_path__ + "static/media/background-top-left.650188bd.png";